module.exports = __webpack_public_path__ + "static/media/smoke.c3921594.gif";